

/* ==========================================================
   CUSTOM PRODUCT BUILDER
   CORNERSTONE-STYLE DESCRIPTION ACCORDION

   Desktop / tablet:
   - faded preview
   - show more / show less
   - smooth animation
   - Cornerstone heading typography

   Mobile:
   - accordion hidden by CSS
   ========================================================== */

/* ==========================================================
   CPB CORNERSTONE DESCRIPTION ACCORDION
   Uses Shopify's localized product description and
   theme locale strings from window.cpbShopifyProduct
   ========================================================== */

function cpbDescriptionAccordion() {
  const description = document.querySelector(
    '#product-builder .cpb-product-description'
  );

  /* Stop if CPB has not loaded or accordion already exists */
  if (
    !description ||
    description.dataset.cornerstoneAccordion === 'true'
  ) {
    return;
  }

  const shopifyProduct =
    window.cpbShopifyProduct || {};

  const shopifyDescription =
    typeof shopifyProduct.description === 'string'
      ? shopifyProduct.description
      : '';

  const text =
    shopifyProduct.accordion || {
      description: 'Description',
      showMore: 'Show more',
      showLess: 'Show less'
    };

  description.dataset.cornerstoneAccordion = 'true';

  /* Replace CPB description with Shopify's localized version */
  if (shopifyDescription.trim() !== '') {
    description.innerHTML = shopifyDescription;
  }

  const contentId =
    'accordion-content-cpb-description';


  /* Create accordion */
  const accordion =
    document.createElement('div');

  accordion.id =
    'cpb-description';

  accordion.className =
    'accordion fs-body-100 product-blocks__accordion cpb-description-accordion';


  const inner =
    document.createElement('div');

  inner.className =
    'accordion__inner';

  inner.dataset.open =
    'false';


  /* Heading button */
  const button =
    document.createElement('button');

  button.type =
    'button';

  button.className =
    'accordion__label';

  button.setAttribute(
    'aria-expanded',
    'false'
  );

  button.setAttribute(
    'aria-controls',
    contentId
  );


  const heading =
    document.createElement('h2');

  heading.className =
    'ff-heading fs-heading-5-base';

  heading.textContent =
    text.description;


  /* Chevron */
  const iconContainer =
    document.createElement('div');

  iconContainer.className =
    'accordion__label-icons cpb-description-chevron';

  iconContainer.setAttribute(
    'aria-hidden',
    'true'
  );

  iconContainer.innerHTML = `
    <svg
      viewBox="0 0 12 8"
      width="12"
      height="8"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M1 1.25L6 6.25L11 1.25"
        fill="none"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `;


  /* Description content */
  const content =
    document.createElement('div');

  content.id =
    contentId;

  content.className =
    'accordion__content rte non-page-rte cpb-description-preview';

  content.setAttribute(
    'aria-hidden',
    'false'
  );


  /* Show more / Show less */
  const showMore =
    document.createElement('button');

  showMore.type =
    'button';

  showMore.className =
    'cpb-description-show-more';

  showMore.textContent =
    text.showMore;

  showMore.setAttribute(
    'aria-controls',
    contentId
  );


  /* Build accordion */
  description.parentNode.insertBefore(
    accordion,
    description
  );

  content.appendChild(
    description
  );

  button.appendChild(
    heading
  );

  button.appendChild(
    iconContainer
  );

  inner.appendChild(
    button
  );

  inner.appendChild(
    content
  );

  inner.appendChild(
    showMore
  );

  accordion.appendChild(
    inner
  );


  /* Calculate collapsed preview height 3 lines for desktp, 2 lines for < 999 screen size */
 
  function getCollapsedDescriptionHeight() {
    const computedStyle = window.getComputedStyle(description);
    let lineHeight = parseFloat(computedStyle.lineHeight);

    if (!lineHeight || Number.isNaN(lineHeight)) {
      const fontSize = parseFloat(computedStyle.fontSize) || 16;
      lineHeight = fontSize * 1.5;
    }

    const lines = window.innerWidth <= 999 ? 2 : 3;
    return Math.round(lineHeight * lines);
  }


  function setCollapsedHeight() {
    if (inner.dataset.open === 'true') {
      return;
    }

    content.style.height =
      getCollapsedDescriptionHeight() + 'px';
  }


  requestAnimationFrame(
    setCollapsedHeight
  );


  /* Open / close accordion */
  function toggleDescription() {
    const isOpen =
      button.getAttribute(
        'aria-expanded'
      ) === 'true';


    /* OPEN */
    if (!isOpen) {
      button.setAttribute(
        'aria-expanded',
        'true'
      );

      inner.dataset.open =
        'true';

      showMore.textContent =
        text.showLess;

      content.classList.add(
        'cpb-description-expanded'
      );


      const startHeight =
        content.getBoundingClientRect().height;

      content.style.height =
        startHeight + 'px';

      content.style.overflow =
        'hidden';

      content.style.height =
        'auto';

      const targetHeight =
        content.scrollHeight;

      content.style.height =
        startHeight + 'px';

      content.offsetHeight;


      requestAnimationFrame(
        function () {
          content.style.height =
            targetHeight + 'px';
        }
      );


      const onOpenEnd =
        function (event) {
          if (
            event.propertyName !== 'height'
          ) {
            return;
          }

          content.style.height =
            'auto';

          content.style.overflow =
            '';

          content.removeEventListener(
            'transitionend',
            onOpenEnd
          );
        };


      content.addEventListener(
        'transitionend',
        onOpenEnd
      );
    }


    /* CLOSE */
    else {
      button.setAttribute(
        'aria-expanded',
        'false'
      );

      inner.dataset.open =
        'false';

      showMore.textContent =
        text.showMore;


      const startHeight =
        content.scrollHeight;

      const targetHeight =
        getCollapsedDescriptionHeight();

      content.style.height =
        startHeight + 'px';

      content.style.overflow =
        'hidden';

      content.offsetHeight;

      content.classList.remove(
        'cpb-description-expanded'
      );


      requestAnimationFrame(
        function () {
          content.style.height =
            targetHeight + 'px';
        }
      );


      const onCloseEnd =
        function (event) {
          if (
            event.propertyName !== 'height'
          ) {
            return;
          }

          content.style.height =
            targetHeight + 'px';

          content.style.overflow =
            'hidden';

          content.removeEventListener(
            'transitionend',
            onCloseEnd
          );
        };


      content.addEventListener(
        'transitionend',
        onCloseEnd
      );
    }
  }


  button.addEventListener(
    'click',
    toggleDescription
  );

  showMore.addEventListener(
    'click',
    toggleDescription
  );


  /* Recalculate preview height on resize */
  let resizeTimer;

  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(
        function () {
          if (
            inner.dataset.open !== 'true'
          ) {
            setCollapsedHeight();
          }
        },
        150
      );
    }
  );
}


/* ==========================================================
   WAIT FOR CPB TO LOAD
   ========================================================== */

const cpbDescriptionObserver =
  new MutationObserver(
    function () {
      cpbDescriptionAccordion();
    }
  );


cpbDescriptionObserver.observe(
  document.documentElement,
  {
    childList: true,
    subtree: true
  }
);


/* Initial run */
cpbDescriptionAccordion();